// extracted by mini-css-extract-plugin
export default {"root":"MedcloudReport_root__k06zA","toolbar":"MedcloudReport_toolbar__MWXyQ"};